// extracted by mini-css-extract-plugin
export default {"container":"Greetings_container__ZEGev"};